import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc5c031e")

_pushScopeId("data-v-fc5c031e")
const _hoisted_1 = { class: "footerSRP" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("p", { class: "mt-3 d-sm-block" }, [
    /*#__PURE__*/_createTextVNode(" ® Todos los derechos reservados. "),
    /*#__PURE__*/_createVNode("small", { class: "float-md-end d-d-sm-block" }, [
      /*#__PURE__*/_createVNode("i", { class: "fas fa-comment-medical fa-lg" }),
      /*#__PURE__*/_createTextVNode("Soporte")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _hoisted_2
  ]))
})